import "../../../../content/projects/pro32/pro32.css";
import * as React from 'react';
export default {
  React
};